import type { HTMLAttributes } from "react";

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export function Skeleton({ className = "", style, ...props }: SkeletonProps) {
  return (
    <div
      {...props}
      data-fz-loading="skeleton"
      style={{
        backgroundImage: "linear-gradient(90deg, var(--fz-loading-skeleton-bg) 25%, var(--fz-loading-skeleton-highlight) 50%, var(--fz-loading-skeleton-bg) 75%)",
        backgroundSize: "200% 100%",
        animation: "fz-loading-skeleton-shimmer 1.5s ease-in-out infinite",
        ...style,
      }}
      className={`rounded-[var(--fz-radius)] ${className}`}
    />
  );
}
